import { vendors_ES_MX } from "#pages/org/vendors/translations";
import { TEAM_ES_MX } from "#pages/team/translations/team-es-mx";
import { merge } from "lodash-es";
import { backofficeEsMX as backoffice } from "./backoffice";
import { components } from "./components";
import es_MXJson from "./es-MX.json";

import { eventMX } from "./event";
import { navES_MX } from "./nav";
import { noAuthESMX as noAuth } from "./no-auth";
import { integrations } from "./org/integrations";
import { categories } from "./org/categories";
import { placeES_MX } from "./place";
import { globalKeysES_MX } from "./global-keys";
import { storeES_MX } from "./store";
import { sharedES_MX } from "./shared";
import { orgES_MX } from "./org";
import { organizationES_MX } from "./organization";
import { REGISTER_EMAIL_ES_MX } from "./recovery/register-email";
import { COVERT_ES_MX } from "#pages/place/settings/couvert/translations/couvert-es-mx";

const es_MX = merge(es_MXJson, {
	backoffice,
	place: {
		...placeES_MX,
		settings: {
			couvertEdit: COVERT_ES_MX,
		},
	},
	components,
	event: {
		...eventMX,
	},
	nav: navES_MX,
	noAuth,
	org: {
		vendors: vendors_ES_MX,
		integrations,
		categories,
		org: orgES_MX,
	},
	organization: organizationES_MX,
	recovery: {
		registerEmail: REGISTER_EMAIL_ES_MX,
	},
	store: storeES_MX,
	team: TEAM_ES_MX,
	globalKeys: globalKeysES_MX,
	shared: sharedES_MX,
});

export { es_MX };
